import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface IGtmOtherPropertyInOffer {
    id: number;
    number: string;
    offerId: number;
    offerName: string;
    referrerPropertyId: number;
}

interface IGtmOtherPropertyInOfferEvent {
    event: "other_property_in_offer";
    detail: {
        products: [IGtmOtherPropertyInOffer];
    };
}

export const gtmOtherPropertyInOfferClick = (product: IGtmOtherPropertyInOffer) => {
    const gtmData: IGtmOtherPropertyInOfferEvent = {
        event: "other_property_in_offer",
        detail: {
            products: [product]
        }
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface IGtmOtherPropertyInOffer {
    id: number;
    number: string;
    offerId: number;
    offerName: string;
    referrerPropertyId: number;
}

interface IGtmOtherPropertyInOfferEvent {
    event: "other_property_in_offer";
    detail: {
        products: [IGtmOtherPropertyInOffer];
    };
}

export const gtmOtherPropertyInOfferClick = (product: IGtmOtherPropertyInOffer) => {
    const gtmData: IGtmOtherPropertyInOfferEvent = {
        event: "other_property_in_offer",
        detail: {
            products: [product]
        }
    };

    hitGoogleTagManager(gtmData);
};
